interface CloudflareCaptchaI {
  executeAsync: () => Promise<void>;
  getResponse: () => string | null;
  reset: () => void;
}

const INTERVAL_DELAY_MS = 1000;

/**
 * Wait when the captcha is ready and get the token from it
 */
export const getCloudflareCaptchaTokenAsync = async (
  captchaRef: React.MutableRefObject<CloudflareCaptchaI | null>,
  intervalDelayMs: number = 500 // Default interval delay
): Promise<string | null> => {
  if (!captchaRef.current) {
    return null;
  }

  captchaRef.current.reset();

  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      if (!captchaRef.current) {
        clearInterval(interval);
        reject(new Error("Captcha reference is no longer available."));
        return;
      }

      const response = captchaRef.current.getResponse();
      if (response) {
        clearInterval(interval);
        resolve(response);
      } else {
        try {
          captchaRef.current.executeAsync();
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }
    }, intervalDelayMs);

    // Optional: Add timeout to avoid infinite loops
    setTimeout(() => {
      clearInterval(interval);
      reject(new Error("Captcha resolution timed out."));
    }, 60_000); // Timeout after 1 minute
  });
};
